import { NeoModel, ValueObject } from "@singularsystems/neo-core";

@NeoModel
export default class ServiceProviderSearchCriteria extends ValueObject {
    
    public searchCriteria: string = "";
}